import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withBgNeutral100, withBgNeutral900} from '@/hocs/withColors';
import {withMarginBottom2xl, withMarginBottomSm} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2, H2Neutral50} from '@/typography';
import Pill from '@/ui/pills';
import Link from '@/links';
import Steps from '@/ui/steps';

const DivMargined2xl = withMarginBottom2xl('div');
const PillMargined = withMarginBottomSm(Pill);
const SectionBgNeutral900 = withBgNeutral900(SectionPadding);
const SectionBgNeutral100 = withBgNeutral100(SectionPadding);

const NativestepsContent = [
  {
    title: 'Apply to become a Technology partner',
    copy: (
      <>
        Fill out a{' '}
        <Link href="/partnership-program/apply" variant="default">
          short form
        </Link>{' '}
        and our partnerships team will be in touch to explore fit. We welcome new native integration
        partners in cohorts starting every other month.
      </>
    )
  },
  {
    title: 'Build your integration',
    copy: 'Once approved, you’ll receive a sandbox account to begin development. You’ll have 90 days to build your integration and get everything ready to launch.'
  },
  {
    title: 'Launch and grow',
    copy: 'You’re in! From here, we’ll team up on co-marketing, co-selling, and driving value together through our partner ecosystem.'
  }
];
const ThirdPartystepsContent = [
  {
    title: 'Apply to become a 3rd party integration partner',
    copy: 'Submit your company details through our application form and accept the partner agreement, which includes a two-way revenue share and listing in our Partner Directory.'
  },
  {
    title: 'Share your integration',
    copy: 'Send us clear instructions and visuals showing how your integration works so we can create a Help Center article that supports your users.'
  },
  {
    title: 'Launch and grow',
    copy: 'Once everything is approved, we’ll publish your listing and Help Center article, then promote your integration across the Partner Directory and other channels.'
  }
];

const IntegrationPartners = () => (
  <>
    <SectionBgNeutral900 id="native-integration-partners">
      <Container>
        <Grid fluid>
          <DivMargined2xl>
            <Row center="xs">
              <Col xs={12} lg={8}>
                <PillMargined variant="yellow200">Getting started</PillMargined>
                <H2Neutral50>Native integration partners</H2Neutral50>
              </Col>
            </Row>
          </DivMargined2xl>
          <Steps stepsContent={NativestepsContent} lineColor="neutral800" />
        </Grid>
      </Container>
    </SectionBgNeutral900>
    <SectionBgNeutral100 id="third-party-integration-partners">
      <Container>
        <Grid fluid>
          <DivMargined2xl>
            <Row center="xs">
              <Col xs={12} lg={8}>
                <PillMargined variant="neutral900">Getting started</PillMargined>
                <H2>3rd party integration partners</H2>
              </Col>
            </Row>
          </DivMargined2xl>
          <Steps
            stepsContent={ThirdPartystepsContent}
            Url="/partnership-program/third-party-partners/apply"
          />
        </Grid>
      </Container>
    </SectionBgNeutral100>
  </>
);

export default IntegrationPartners;
